import React from "react";

const NoIndexMeta = () => {
  const shouldAddNoIndex =
    process.env.NEXT_PUBLIC_APPLICATION_ON === "PROD" ? true : false;
  return shouldAddNoIndex ? <meta name="robots" content="noindex" /> : <></>;
};

export default NoIndexMeta;
